































































































































import PortalInput from "@/components/common/PortalInput.vue";
import { CreatePTOPolicyPayload } from "@/dto/payroll/policies/PTOPolicyDTO";
import { Component, Prop, Vue } from "vue-property-decorator";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import { ContractType, contractTypeOptions, EmploymentType } from "@/constants/EmploymentType";
import { STATE_LIST } from "@/constants/ProfileConstants";
import SelectOption from "@/components/common/SelectOption";
import Application from "@/state/Application";
import { ifValid, processError } from "@/utils/ComponentUtils";
import PolicyService from "@/services/payroll/PolicyService";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import CompanyService from "@/services/CompanyService";
import BranchDto from "@/components/profile/branches/BranchDtos";
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import FileMetaDTO from "@/dto/files/FileMetaDTO";

@Component({
	components: { PortalRadio, PortalSelect, PortalCheckbox, PortalInput, EmbeddedFile },
	methods: { contractTypeOptions },
	computed: {
		ContractType() {
			return ContractType;
		},
		SelectOption() {
			return SelectOption;
		},
		STATE_LIST() {
			return STATE_LIST;
		}
	}
})
export default class PTOCreationModal extends Vue {
	@Prop()
	private callback!: () => void;

	@Prop({ default: null })
	private companyId!: number | null;

	@Prop({ default: null })
	private draftPolicyId!: number | null;

	private states = STATE_LIST;
	private branches: BranchDto[] = [];
	private step: 1 | 2 = 1;
	private createdPolicyId: number | null = null;
	private draftFileMeta: FileMetaDTO | null = null;
	private submitting = false;

	private get effectiveCompanyId(): number {
		return this.companyId != null ? this.companyId : this.$wss.getCurrent.id;
	}

	private req: CreatePTOPolicyPayload = new CreatePTOPolicyPayload({
		companyId: this.$wss.getCurrent.id
	});

	private selectedBranch: BranchDto | null = null;

	public mounted(): void {
		this.req.companyId = this.effectiveCompanyId;
		if (this.draftPolicyId != null) {
			this.createdPolicyId = this.draftPolicyId;
			this.step = 2;
			Application.startLoading();
			PolicyService.resolveDraftPTO(this.draftPolicyId).then(
				draftRes => {
					Application.stopLoading();
					this.draftFileMeta = draftRes.data ?? null;
				},
				err => {
					processError(err, this);
					Application.stopLoading();
					this.draftFileMeta = null;
				}
			);
			return;
		}
		Application.startLoading();
		Promise.all([
			CompanyService.getHeadQuarter(this.effectiveCompanyId).then(
				res => { if (res.data) this.branches.push(res.data); },
				err => processError(err, this)
			),
			CompanyService.getBranches(this.effectiveCompanyId).then(
				res => { if (res.data) this.branches.push(...res.data); },
				err => processError(err, this)
			)
		]).then(() => Application.stopLoading());
	}

	private submitForm(): void {
		ifValid(this, () => {
			Application.startLoading();
			if (this.selectedBranch) this.req.branchId = this.selectedBranch.id;
			PolicyService.createPTOPolicy(this.req)
				.then(createRes => {
					const policyId = createRes.data;
					if (policyId == null) {
						Application.stopLoading();
						this.$modal.hideAll();
						this.callback();
						return;
					}
					this.createdPolicyId = policyId;
					this.step = 2;
					Application.stopLoading();
					PolicyService.resolveDraftPTO(policyId).then(
						draftRes => {
							this.draftFileMeta = draftRes.data ?? null;
						},
						err => {
							processError(err, this);
							this.draftFileMeta = null;
						}
					);
				})
				.catch(err => {
					processError(err, this);
					Application.stopLoading();
				});
		});
	}

	private discardDraft(): void {
		if (this.createdPolicyId == null) return;
		this.submitting = true;
		Application.startLoading();
		PolicyService.deleteDraftPTO(this.createdPolicyId).then(
			() => {
				Application.stopLoading();
				this.submitting = false;
				this.createdPolicyId = null;
				this.draftFileMeta = null;
				this.step = 1;
			},
			err => {
				processError(err, this);
				Application.stopLoading();
				this.submitting = false;
			}
		);
	}

	private confirmPolicy(): void {
		if (this.createdPolicyId == null) return;
		this.submitting = true;
		Application.startLoading();
		PolicyService.confirmPTO(this.createdPolicyId).then(
			() => {
				Application.stopLoading();
				this.submitting = false;
				this.$modal.hideAll();
				this.callback();
			},
			err => {
				processError(err, this);
				Application.stopLoading();
				this.submitting = false;
			}
		);
	}

	private selectState(): void {
		this.req.title = `PTO (Paid Time Off) Policy (${this.req.applicableState})`;
	}

	private onCancel(): void {
		if (this.callback) this.callback();
		this.$modal.hideAll();
	}

	private get contractType(): SelectOption[] {
		const options: SelectOption[] = [];
		options.push(SelectOption.builder().title("All").value(null).build());
		options.push(...contractTypeOptions([ContractType.FIXED_TERM]));
		return options;
	}

	private get employmentOptions(): SelectOption[] {
		return [
			SelectOption.builder().title("All").value(null).build(),
			SelectOption.builder().title("Employee").value(EmploymentType.STAFF).build(),
			SelectOption.builder().title("Foreign employee").value(EmploymentType.FOREIGN).build()
		];
	}
}
